import { getDataFromPocket } from '../../utils/pocket';
import type { UserInfo } from './utils-pocket-models';

export const CLOUDFLARE_COOKIE_FIELDS = [
    { name: 'cfScore', placeholder: '%%CLIENT_BOT_SCORE%%' },
    { name: 'cfSource', placeholder: '%%CLIENT_BOT_SOURCE%%' },
    { name: 'cfVerified', placeholder: '%%CLIENT_BOT_VERIFIED%%' },
    { name: 'cfVerifiedCat', placeholder: '%%CLIENT_BOT_VERIFIED_CATEGORY%%' },
    { name: 'cfTags', placeholder: '%%CLIENT_BOT_TAGS%%' },
    { name: 'cfIds', placeholder: '%%CLIENT_BOT_IDS%%' },
] as const;

export type CloudflareCookieName = typeof CLOUDFLARE_COOKIE_FIELDS[number]['name'];
export type CloudflareCookieValues = Partial<Record<CloudflareCookieName, string>>;

export function getClientIpSource(): 'internal' | 'external' {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    switch (clientInfo?.ipSource) {
        case 'internal':
        case 'external':
            return clientInfo.ipSource;
        default:
            return 'external';
    }
}

export function getClientJA3(): string {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    if (!clientInfo) {
        return '';
    }

    switch (clientInfo.ja3) {
        case '%%CLIENT_JA3%%':
            return '';
        default:
            return clientInfo.ja3;
    }
}

export function getClientJA4(): string {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    if (!clientInfo) {
        return '';
    }

    switch (clientInfo.ja4) {
        case '%%CLIENT_JA4%%':
            return '';
        default:
            return clientInfo.ja4;
    }
}

export function getClientCloudflareInfo(): CloudflareCookieValues {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');
    const result: CloudflareCookieValues = {};

    CLOUDFLARE_COOKIE_FIELDS.forEach((field) => {
        const value = clientInfo?.[field.name];

        if (value?.trim() && value !== field.placeholder) {
            result[field.name] = value;
        }
    });

    return result;
}
